import {isMobile} from "../common/utils";

jQuery(document).ready(($) => {
    if (isMobile()) {
        $('#broadcast_widget').get(0).addEventListener('sport1WidgetLoaded', function () {
            $('.broadcasts-list .show-title').each(function () {
                if ($(this).text() && $(this).text().trim()) {
                    if (this) {
                        $clamp(this, {clamp: 2, truncationChar: '...'});
                    }
                }
            });
        });
    }
});